import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-ventas',
  templateUrl: './main-ventas.component.html',
  styleUrls: ['./main-ventas.component.css']
})
export class MainVentasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
